import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";
import type {
  Enrollment,
  EnrollmentFilter,
  EnrollmentRemoval,
  EnrollmentStats,
  ReadmitResult,
  RemovalFilter,
  RemoveStudentData,
} from "./types";

export * from "./types";

/** Yozilishlar API — backend'dagi `EnrollmentsController` ning ko'zgusi. */
export class EnrollmentsApi extends BaseApi {
  private readonly baseUrl: string = "/enrollments";

  /** Joriy o'quvchini kursga yozadi. */
  enroll(courseId: number) {
    return this.request.post<Enrollment, ApiResponse<Enrollment>>(
      `${this.baseUrl}/course/${courseId}`,
    );
  }

  /** Kursga yozilishimni bekor qiladi. */
  unenroll(courseId: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/course/${courseId}`);
  }

  /** Men yozilgan kurslar. */
  getMy(filter: EnrollmentFilter) {
    return this.request.get<Enrollment[], Pagination<Enrollment>>(`${this.baseUrl}/my`, {
      params: filter,
    });
  }

  /** Bitta kursga yozilish holatim (yozilmagan bo'lsam `null`). */
  getMyStatus(courseId: number) {
    return this.request.get<Enrollment | null, ApiResponse<Enrollment | null>>(
      `${this.baseUrl}/course/${courseId}/me`,
    );
  }

  /** Kursga yozilgan o'quvchilar ro'yxati (o'qituvchi/admin). */
  getRoster(courseId: number, filter: EnrollmentFilter) {
    return this.request.get<Enrollment[], Pagination<Enrollment>>(
      `${this.baseUrl}/course/${courseId}`,
      { params: filter },
    );
  }

  /** Kurs bo'yicha yozilishlar soni, holat kesimida (o'qituvchi/admin). */
  getStats(courseId: number) {
    return this.request.get<EnrollmentStats, ApiResponse<EnrollmentStats>>(
      `${this.baseUrl}/course/${courseId}/stats`,
    );
  }

  // ── Chetlashtirish ──

  /** Talabani sabab bilan chetlashtiradi (muallif yoki admin). */
  removeStudent(courseId: number, studentId: number, data: RemoveStudentData) {
    return this.request.post<EnrollmentRemoval, ApiResponse<EnrollmentRemoval>>(
      `${this.baseUrl}/course/${courseId}/students/${studentId}/remove`,
      data,
    );
  }

  /** Chetlashtirilgan talabani qayta tiklaydi (muallif yoki admin). */
  readmitStudent(courseId: number, studentId: number, note?: string) {
    return this.request.post<ReadmitResult, ApiResponse<ReadmitResult>>(
      `${this.baseUrl}/course/${courseId}/students/${studentId}/readmit`,
      { note },
    );
  }

  /** Bitta kursning chetlashtirishlar tarixi. */
  getCourseRemovals(courseId: number) {
    return this.request.get<EnrollmentRemoval[], ApiResponse<EnrollmentRemoval[]>>(
      `${this.baseUrl}/course/${courseId}/removals`,
    );
  }

  /** Butun platforma bo'yicha chetlashtirishlar (moderator va admin). */
  listRemovals(filter: RemovalFilter) {
    return this.request.get<EnrollmentRemoval[], Pagination<EnrollmentRemoval>>(
      `${this.baseUrl}/removals`,
      { params: filter },
    );
  }
}

export const enrollmentsApi = new EnrollmentsApi();
